<template>
  <div class="content">
    <router-link to="/">
      <img class="logo" src="/static/logo.png" />
    </router-link>
    <div class="form">
      <div class="title">{{$t('global.重置密码')}}</div>
      <div class="warp">
        <input :type="pwdType" class="form-input" v-model="password" :placeholder="$t('global.密码')" />
        <i
          v-if="this.pwdType !== 'password'"
          class="el-icon-view password-view"
          @click="changeType(1)"
        ></i>
        <i v-else class="iconfont password-view" @click="changeType(1)">&#xe6d0;</i>
      </div>

      <div class="warp">
        <input :type="pwdType1" class="form-input" v-model="repassword" :placeholder="$t('global.确认密码')" />
        <i
          v-if="this.pwdType1 !== 'password'"
          class="el-icon-view repassword-view"
          @click="changeType(2)"
        ></i>
        <i v-else class="iconfont repassword-view" @click="changeType(2)">&#xe6d0;</i>
      </div>
      <el-button type="primary" class="btn-login" @click="resetPassword">{{$t('global.重置密码')}}</el-button>
      <div class="login-text">
        <router-link class="reg-link" to="/login">{{$t('global.直接登录')}}</router-link>
      </div>
    </div>
    <div class="footer-row">
      <div class="footer-copyright">
        Copyright 2016-{{dataYear}} 吗呐（MANA）All Rights Reserved.
        <a
          href="http://beian.miit.gov.cn/"
          target="_blank"
        >沪ICP备16019863号</a>
        <img src="/static/police.png" />
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31010402333867" target="_blank"
        >沪公网安备 31010402333867号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resetPassword",
  metaInfo() {
    return {
      title: this.$t("global.重置密码") + " | MANA"
    };
  },
  data() {
    return {
      dataYear: null,
      name: "",
      email: "",
      password: "",
      repassword: "",
      agree: true,
      pwdType: "password",
      pwdType1: "password"
    };
  },
  created() {
    var date = new Date();
    this.dataYear = date.getFullYear();
  },
  methods: {
    changeType(index) {
      if (index === 1) {
        this.pwdType = this.pwdType === "password" ? "text" : "password";
      } else {
        this.pwdType1 = this.pwdType1 === "password" ? "text" : "password";
      }
    },
    resetPassword() {
      let reg1 = /\S{7,}/;
      let reg2 = /^\d+$/;
      if (!reg1.test(this.password) || reg2.test(this.password)) {
        this.$message({
          message: "密码不少于7位，且不能为纯数字!",
          type: "warning"
        });
        return;
      }
      if (this.repassword !== this.password) {
        this.$message({
          message: this.$t('global.两次输入的密码不一致'),
          type: "error"
        });
        return;
      }
      if (this.$query.code) {
        this.$http
          .post("/api/passport/resetPassword", {
            password: this.password,
            confirmPassword: this.repassword,
            code: this.$query.code
          })
          .then(response => {
            if (response.code === "OK") {
              this.$router.push("/login");
              this.$message({
                message: response.message,
                type: "success"
              });
            } else {
              this.$message({
                message: response.message,
                type: "error"
              });
            }
          });
      } else {
        const resetObj = sessionStorage.getItem("resetPassword");
        if (resetObj) {
          const url = `/api/passport/resetMobilePassword`;
          const params = JSON.parse(resetObj);
          this.$http
            .post(url, { ...params, password: this.password })
            .then(res => {
              if (res.code === "OK") {
                this.$router.replace("/login");
              }
            });
        }
      }
    }
  }
};
</script>

<style scoped>
.warp {
  position: relative;
}
.logo {
  position: absolute;
  left: 1.8rem;
  top: 0.3rem;
  display: inline-block;
  width: 1.3rem;
  height: 0.34rem;
}
.content {
  width: 100%;
  height: 100%;
  background: url("/static/login/login-back.jpg") no-repeat center center;
  background-size: cover;
  padding-top: 4.2rem;
  position: relative;
  box-sizing: border-box;
}
.content:before {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.form {
  width: 4rem;
  height: 6.14rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.title {
  color: #fff;
  font-size: 0.36rem;
  text-align: center;
  margin-bottom: -0.05rem;
}

.form-input {
  height: 0.64rem;
  border: 0.02rem solid white;
  box-sizing: border-box;
  line-height: 0.6rem;
  font-size: 0.2rem;
  background-color: transparent;
  width: 100%;
  padding: 0 0.28rem;
  -webkit-border-radius: 0.06rem;
  -moz-border-radius: 0.06rem;
  border-radius: 0.06rem;
  margin-top: 0.4rem;
  color: #fff;
}

input[type="text"]::-webkit-input-placeholder,
input[type="password"]::-webkit-input-placeholder {
  color: #fff;
}

input[type="text"]:-moz-placeholder,
input[type="password"]:-moz-placeholder {
  color: #fff;
}

input[type="text"]::-moz-placeholder,
input[type="password"]::-moz-placeholder {
  color: #fff;
}

input[type="text"]:-ms-input-placeholder,
input[type="password"]:-ms-input-placeholder {
  color: #fff;
}

.password-view {
  font-size: 0.26rem;
  color: #fff;
  position: absolute;
  right: 0.3rem;
  /* top: 1.02rem; */
  bottom: 12px;
  cursor: pointer;
}
.repassword-view {
  font-size: 0.26rem;
  color: #fff;
  position: absolute;
  right: 0.3rem;
  /* top: 2.1rem; */
  bottom: 12px;
  cursor: pointer;
}
.div-rememberme {
  overflow: hidden;
  zoom: 1;
  margin-top: 0.25rem;
}
.checkbox-rememberme {
  color: #fff;
  font-size: 0.18rem;
}
.forget-link {
  float: right;
  vertical-align: middle;
  font-size: 0.18rem;
  color: #fff;
}
.btn-login {
  width: 100%;
  margin: 0.35rem 0 0.2rem;
}
.login-text {
  font-size: 0.16rem;
  color: #fff;
}
.login-text a {
  color: #0161ff;
  text-decoration: underline;
}
.login-way-title {
  margin: 0.75rem 0 0.35rem;
  text-align: center;
  font-size: 0.18rem;
  color: #999999;
}
.login-ways {
  text-align: center;
}
.login-way {
  display: inline-block;
  width: 0.36rem;
  height: 0.36rem;
  margin: 0 0.275rem;
}
.login-way-qq {
  background: url("/static/qq.png") no-repeat center center;
  background-size: contain;
}
.login-way-wechat {
  background: url("/static/wechat.png") no-repeat center center;
  background-size: contain;
}
.login-way-weibo {
  background: url("/static/weibo.png") no-repeat center center;
  background-size: contain;
}
.footer-row {
  width: 8.5rem;
  margin: 5.7rem auto 0;
  zoom: 1;
}
.footer-row:after {
  content: "";
  display: block;
  clear: both;
}
.footer-copyright {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.16rem;
  color: #eee;
  text-align: center;
}
.footer-copyright > a {
  color: #eee;
}
.footer-copyright > img {
  display: inline-block;
  margin: -0.04rem 0.1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/passport/resetPassword.vue